import React from 'react'
import { Box, Card, CardHeader, Typography } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import GetAppIcon from '@material-ui/icons/GetApp'
import { saveAs } from 'file-saver'

const downloadImage = (url) => {
    saveAs(url, 'vaccination_certificate.jpg') // Put your image url here.
}

// const useStyles = (theme) => ({
//   media: {
//     height: "500px",
//     paddingTop: "56.25%", // 16:9
//   },
// });

export const VaccinationDetailsTab = ({ vaccination }) => {
    console.log(vaccination)

    const { status, urlLink } = vaccination
    const vaccinationStatus = status

    return (
        <Box
            p={2}
            pb={2}
            pt={2}
            sx={{
                minHeight: '450px',
                // border: "solid 1px red",
            }}
        >
            <Box>
                <Card variant="outlined">
                    <CardHeader
                        action={
                            urlLink && (
                                <IconButton
                                    aria-label="download vaccination certificate"
                                    onClick={() => downloadImage(urlLink)}
                                >
                                    <GetAppIcon />
                                </IconButton>
                            )
                        }
                        title={<Typography style={{ fontWeight: '550' }}>Vaccination certificate</Typography>}
                        subheader={<Typography style={{ fontSize: '0.9rem' }}>{vaccinationStatus}</Typography>}
                    />
                    {/* <CardMedia
            className={classes.media}
            // image={<img src={vaccinationCert} />}
            src={vaccinationCert}
            title="Vaccination Certificate"
          /> */}
                    {urlLink && (
                        <img
                            // className={classes.media}
                            style={{ height: '400px', marginLeft: 12 }}
                            src={urlLink}
                            alt="vaccination certificate"
                        />
                    )}
                </Card>
            </Box>
        </Box>
    )
}
